import { Model } from 'app/model/backendmodel';
import { Owned } from 'app/model/base/named';
import { IModel } from 'app/model/base/annotation';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';
import { CompressionReadSettings } from 'app/model/pipeline/copysource/compression-read-settings/compression-read-settings';
import { BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';

export const compressionReadSettingsAdapts = {
    type: '*'
};

export abstract class CompressionReadSettingsAdapter<T, U> extends BaseAsyncAdapter<T, U> {
    public static getCommonCompressionReadSettingsProperties(settingType: string): Model.CompressionReadSettings {
        return {
            type: settingType
        };
    }

    public static createCompressionReadSettingsWithCommonProperties(
        model: IModel,
        formatReadSettings: FormatReadSettings
    ): CompressionReadSettings {
        return Owned.create<CompressionReadSettings>(model, formatReadSettings);
    }

    protected async _toAzureResource(tridentResource: ITridentResource): Promise<U> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
